const themeStorageKey = 'telemedInstitutionalTheme';

export const institutionalTheme = {
  applicationName: process.env.REACT_APP_APP_NAME || 'TeleMec',
  institutionName: process.env.REACT_APP_INSTITUTION_NAME || 'TeleMec',
  logoText: process.env.REACT_APP_LOGO_TEXT || 'TMC',
  logoUrl: process.env.REACT_APP_LOGO_URL || '',
  developerName: process.env.REACT_APP_DEVELOPER_NAME || 'SAG Ecuador',
  developerUrl: process.env.REACT_APP_DEVELOPER_URL || 'https://platinumtics.com',
  developerDisplayUrl: process.env.REACT_APP_DEVELOPER_DISPLAY_URL || 'platinumtics.com',
  colors: {
    primary: process.env.REACT_APP_COLOR_PRIMARY || '#173653',
    secondary: process.env.REACT_APP_COLOR_SECONDARY || '#236eaa',
    text: process.env.REACT_APP_COLOR_TEXT || '#263746',
    muted: process.env.REACT_APP_COLOR_MUTED || '#526171',
    border: process.env.REACT_APP_COLOR_BORDER || '#d8e2ea',
    background: process.env.REACT_APP_COLOR_BACKGROUND || '#f8fafc',
    danger: process.env.REACT_APP_COLOR_DANGER || '#9a3412',
  },
};

const mergeTheme = (base, override = {}) => ({
  ...base,
  ...override,
  applicationName: override.applicationName || base.applicationName,
  colors: {
    ...base.colors,
    ...(override.colors || {}),
  },
});

const cleanLegacyTheme = (theme = {}) => {
  const nextTheme = { ...theme };
  if (nextTheme.institutionName === 'Telemedicina Pro') nextTheme.institutionName = institutionalTheme.institutionName;
  if (nextTheme.logoText === 'TMP') nextTheme.logoText = institutionalTheme.logoText;
  if (!nextTheme.applicationName) nextTheme.applicationName = institutionalTheme.applicationName;
  return nextTheme;
};

export const getInstitutionalTheme = () => {
  if (typeof localStorage === 'undefined') return institutionalTheme;
  try {
    const storedTheme = cleanLegacyTheme(JSON.parse(localStorage.getItem(themeStorageKey) || '{}'));
    return mergeTheme(institutionalTheme, storedTheme);
  } catch (error) {
    localStorage.removeItem(themeStorageKey);
    return institutionalTheme;
  }
};

export const notifyInstitutionalThemeUpdated = (theme) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('institutional-theme-updated', { detail: theme }));
};

export const saveInstitutionalTheme = (theme) => {
  const nextTheme = mergeTheme(institutionalTheme, theme);
  localStorage.setItem(themeStorageKey, JSON.stringify(nextTheme));
  applyInstitutionalTheme(nextTheme);
  notifyInstitutionalThemeUpdated(nextTheme);
  return nextTheme;
};

export const resetInstitutionalTheme = () => {
  localStorage.removeItem(themeStorageKey);
  applyInstitutionalTheme(institutionalTheme);
  notifyInstitutionalThemeUpdated(institutionalTheme);
  return institutionalTheme;
};

export const applyInstitutionalTheme = (theme = getInstitutionalTheme()) => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--institution-${key}`, value);
  });
  root.style.setProperty('--institution-name', `"${theme.institutionName}"`);
  root.style.setProperty('--application-name', `"${theme.applicationName || theme.institutionName}"`);
};
